import React from "react";
import {
  Grid,
  CardContent,
  CardHeader,
  Divider,
  Card,
  Fab,
} from "@material-ui/core";
import StockFeesTable from "./StockFeesTable";
import { usePageStyles } from "../../pageStyles";
import { SearchBox } from "../../components/common/SearchBox";
import { PageComponent, AccessRights } from "../../../core/navigation/types";
import AddIcon from "@material-ui/icons/Add";
import { useStockFeeSearch } from "../../../data/clearing/stockfees/hooks/useStockFeeSearch";
import { useHistory } from "react-router-dom";
import { PageTitle } from "../../components/common/PageTitle";
import { getStockFeesEditLocation } from "./Locations";

const StockFeesPage: PageComponent = ({ userAccessRights }) => {
  const pageStyles = usePageStyles();

  const [search, setSearch] = useStockFeeSearch();
  const history = useHistory();

  return (
    <Grid container className={pageStyles.root}>
      <Grid item xs={12} className={pageStyles.gridItem}>
        <Card>
          <CardHeader
            title={<PageTitle title="stockFeeTitle" />}
            action={<SearchBox search={search} setSearch={setSearch} />}
          />
          <Divider />
          <CardContent>
            <StockFeesTable userAccessRights={userAccessRights} />
          </CardContent>
        </Card>
        {userAccessRights === AccessRights.All && (
          <Fab
            color="secondary"
            aria-label="add"
            className={pageStyles.mainFab}
            onClick={() => history.push(getStockFeesEditLocation())}
          >
            <AddIcon />
          </Fab>
        )}
      </Grid>
    </Grid>
  );
};

export default StockFeesPage;
